import TileCarousel from './TileCarousel';

export default TileCarousel;
